import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'src/config/withRouter';
import { reauth_partner, remove_user } from 'src/store/action';
import firebase from 'src/config/firebase';
import { toast, ToastContainer } from 'react-toastify';
import { Dialog } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
import '../../assets/stylesheet/login.css';
var CryptoJS = require("crypto-js");

const styles = () => ({
    dialogContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding:'10px'
    },

    button:{
        alignSelf:'flex-end',
        marginTop:'10px',
        textDecoration: 'none',
        border: 'none',
        outline: 'none',
        color: '#0F467A',
        padding: '12px',
        borderRadius: '28px',
        cursor: 'pointer',
        textTransform: 'uppercase',
        letterSpacing:'1px',
        textAlign: 'center',
        transition:'1s',
        fontWeight:'bold',
        "&:hover":{
            color:'#fff',
            backgroundColor: '#0F467A',
        }
    },

    dialogRoot:{
        zIndex: '1111111 !important'
    },

    titleSpan:{
        textTransform:'uppercase',
        color:'#0F467A',
        fontWeight:'bold'
    }
})

class ReAuthDialog extends React.Component {
    _isMounted = false;
    constructor() {
        super();
        this.state ={
            pwd: '',
            pwdVisible:''
        }
    }

    inputHandleChange = e => {
        this._isMounted = true;
        if(this._isMounted) this.setState({[e.target.name]:e.target.value});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    
    handleClose = () => {
        this._isMounted = true;
        if(this._isMounted) this.props.set_reauth(false);
	}

    visiblePwd = () => {
        this._isMounted = true;
        const {pwdVisible} = this.state;
        if(this._isMounted) this.setState({pwdVisible:!pwdVisible});
    }
    
    reAuth = e => {
        const { company } = this.props;
        const { pwd } = this.state;
        e.preventDefault();
        const encryptPass = company && company.reAuthPass;
        if(!pwd) {
            toast.error('Please enter password to confirm');
        }
        else if(!encryptPass) {
            toast.error('Password does not match, try again');
            this.logoutUser();
        }
        else {
            const reAuthPass = CryptoJS.AES.decrypt(encryptPass, process.env.REACT_APP_LMS_PASS_HASH_SECRET).toString(CryptoJS.enc.Utf8);
            if(reAuthPass === pwd) {
                toast.success('Re Authentication successfully');
                setTimeout(()=> this.props.set_reauth(true),1000);
            }
            else{
                toast.error('Password does not match');
            }
        }
    }

    logoutUser = () => {
        firebase.auth().signOut().then(() => {
        })
        this.props.logout_user();
        this.props.history.push('/');
    }
    
    render() {
        const { classes, t, i18n , company, tReady, reauth, ...other } = this.props;
        const { pwd, pwdVisible } = this.state;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
        return (
            <Dialog fullWidth onClose={this.handleClose} classes={{root:classes.dialogRoot}} aria-labelledby="alertDialog" {...other} open={!reauth}>
            <form onSubmit={this.reAuth} className={classes.dialogContainer}>
                    <span className={`${classes.titleSpan} title`}>Re Auth</span>
                    <div className='inputDiv'>
                        <input type={pwdVisible ? 'text' : 'password'} value={pwd} onChange={this.inputHandleChange} name='pwd' placeholder='Confirm Password' className='inputField'/>
                        {
                            pwdVisible ?
                            <Visibility className='icon' onClick={this.visiblePwd}/>
                            :
                            <VisibilityOff className='icon' onClick={this.visiblePwd}/>
                        }
                    </div>
                    <div className={classes.button} onClick={this.reAuth} style={{fontFamily}}>{t('accept-dialog.confirm-btn')}</div>
            </form>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                limit={3}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover={false}
                style={{fontFamily:"'Poppins', sans-serif"}}
            />
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return{
      reauth: state.reauth,
      company: state.company
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
        set_reauth : status => dispatch(reauth_partner(status)),
        logout_user : () => dispatch(remove_user()),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)
(withStyles(styles)
(withTranslation('common')(ReAuthDialog))));